import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=39d7f86a&scoped=true&"
import script from "./Transfer.vue?vue&type=script&lang=js&"
export * from "./Transfer.vue?vue&type=script&lang=js&"
import style0 from "./Transfer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Transfer.vue?vue&type=style&index=1&id=39d7f86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d7f86a",
  null
  
)

export default component.exports